<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-form-row @keyup.enter="load">
                    <b-col lg="6" sm="8" class="text-left">
                        <lg-finder-page-unidade-administrativa :prefix="prefix + title + ' > '" v-model="form.departamento"
                            id="finderUnidadeAdministrativaUsuario" @onselect="handleUnidadeAdministrativaSelect"
                            invalidFeedback="Unidade Administrativa deve ser informada!"
                            description="Selecione a unidade Administrativa">
                        </lg-finder-page-unidade-administrativa>
                    </b-col>
                    <b-col lg="2" sm="4" class="text-left">
                        <lg-form-const-select label="Situação:" v-model="form.situacaoUsuario"
                            :options="form.optionsFilterSituacao" @change="load" />
                    </b-col>

                    <b-col sm="12" lg="4" class="text-right mt-2">
                        <b-button id="apagarUsuario" class="mr-2 my-2" size="sm" pill style="height: 20px"
                            @click="clearForm">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="eraser" /> &nbsp;
                            </div>
                            <b-tooltip target="apagarUsuario" title="Limpar"></b-tooltip>

                        </b-button>

                        <b-button id="localizarUsuarioList" class="mr-2 my-2" style="height: 20px" size="sm" pill
                            variant="primary" @click="load()">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" /> &nbsp;
                            </div>
                            <b-tooltip target="localizarUsuarioList" title="Localizar"></b-tooltip>

                        </b-button>

                        <b-button v-if="pessoa != null" id="adicionarNovoUsuario" class="mr-2 my-2" size="sm" pill
                            variant="primary" @click="adicionarNovo" style="height: 20px">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="plus" />
                            </div>
                            <b-tooltip title="Adicionar novo..." target="adicionarNovoUsuario"></b-tooltip>

                        </b-button>

                    </b-col>

                    <div>
                        <b-form-checkbox @change="load" id="checkbox-1" v-model="form.tipoUsuario" name="checkbox-1"
                            :value="1" :unchecked-value="0">
                            Exibir estagiarios e terceirizados
                        </b-form-checkbox>
                    </div>

                    <b-col lg="4" sm="12" class="text-left mt-2">
                        <lg-form-input v-model="form.nome" placeholder="Nome" description="" />
                    </b-col>

                </b-form-row>


            </b-card>

            <b-card bg-variant="light">
                <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records"
                    :fields="this.tableFields" :hover="true" @row-dblclicked="usuarioResponsavelSelect" show-empty>

                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>


                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>

                    <template v-slot:cell(situacaoUsuario)="row">
                        <div :id="row.index + 'switchGrupo-usuario'">
                            <b-form-checkbox v-model="row.item.situacaoUsuario" @change="alteraSituacao(row.item)"
                                name="check-button" switch size="lg" :value="1" :unchecked-value="0" />
                            <b-tooltip :target="row.index + 'switchGrupo-usuario'"
                                title="Ativar/Desativar..."></b-tooltip>
                        </div>
                    </template>


                </b-table>


                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>

        <UsuarioForm :pessoa="pessoa" v-if="mostrarUsuarioForm" @close="fecharModalForm" :prefix="[prefix + title ]" ></UsuarioForm>
    </b-card>
</template>

<script>
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue";
import ResourceService from "@/core/api/ResourceService";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import { ListResourceMixin } from "@/core/mixins/resource";
import ConfirmMixin from "@/core/mixins/confirm"
import UsuarioForm from "./UsuarioForm.vue";

export default {
    name: "UsuarioList",

    components: {
        LgFormInput,
        LgFormConstSelect,
        LgFinderPageUnidadeAdministrativa,
        UsuarioForm
    },

    props: {
        pessoa: {
            type: Number,
            default: null
        },
        prefix: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: "Usuário"
        },
    },

    data() {
        return {
            mostrarUsuarioForm: false,
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            filtro: "",
            form: {
                tipoUsuario: 0,
                nome: "",
                departamento: {},
                usuario: null,
                unidadeAdministrativa: undefined,
                situacaoUsuario: 1,
                optionsFilterSituacao: [
                    { key: "filterSituacao", text: "Todos", value: undefined },
                    { key: "filterSituacao", text: "Ativo", value: 1 },
                    { key: "filterSituacao", text: "Inativo", value: 0 },
                ],
            },
        };
    },
    mixins: [ListResourceMixin, ConfirmMixin],
    beforeMount() {
        this.$service = new ResourceService(`/api/sgu/usuarios`);
    },

    mounted() {
        this.load();
    },

    watch: {
        page() {
            this.load();
        },

        "form.codDepartamentoSgu"() {
            this.load();
        },
    },

    computed: {

        tableFields() {
            return [
                {
                    key: "id",
                    label: "Código SGU",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "nome",
                    label: "Usuário",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "login",
                    label: "Login",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "matricula",
                    label: "Matrícula",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "codDepartamentoSgu.nome",
                    label: "Unidade Administrativa",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "situacaoUsuario",
                    label: " ",
                    tdClass: "text-center",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
            ];
        },
    },

    methods: {
        fecharModalForm() {
            this.mostrarUsuarioForm = false;
        },
        adicionarNovo() {
            this.mostrarUsuarioForm = true;
        },
        usuarioResponsavelSelect(usuario) {
            this.$emit("onselect", usuario)

        },
        async alteraSituacao(item) {
            let response = await this.$confirm(
                "Deseja " + (item.situacaoUsuario === 1 ? "ativar" : "desativar") + " o Usuário?",
                item.nome.toUpperCase()
            )
            if (response == true) {
                this.confirmarAlteracaoSituacao(item)
            } else {
                item.situacaoUsuario = item.situacaoUsuario === 1 ? 0 : 1
            }
        },


        async confirmarAlteracaoSituacao(item) {
            item.situacao = item.situacaoUsuario;
            const { status } = await this.$service.alteraSituacao(item);
            if (status == 200) {
                this.$notify({
                    type: "success",
                    message: `Registro ${item.situacao ? "Ativado" : "Desativado"
                        } com sucesso!`,
                })
            } else {
                this.$notify({
                    type: "danger",
                    message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
                        } o registro!`,
                })
            }
        },

        sincronizarDados() {
            this.$notify({
                type: "warning",
                message: "Em desenvolvimento",
            });

        },
        async load() {
            this.filtro = {};

            if (this.form.tipoUsuario) {
                this.filtro.tipoUsuario = this.form.tipoUsuario;
            }
            if (this.form.nome && this.form.nome.length > 0) {
                this.filtro.nome = this.form.nome;
            }

            if (this.form.departamento && this.form.departamento.id) {
                this.filtro.departamento = this.form.departamento.setorId;
            }

            if (this.form.situacaoUsuario != undefined) {
                this.filtro.situacao = this.form.situacaoUsuario;
            }

            this.busy = true;
            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtro,
            });
        },

        clearForm() {
            this.form.nome = "";
            this.form.departamento = {};
            this.form.situacaoUsuario = 1;
            this.form.tipoUsuario = 0;

            this.load();
        },

        handleUnidadeAdministrativaSelect(item) {
            this.form.departamento = item;
            this.load();
        },


    },
};
</script>
